import {
  SET_FEEDBACK_RECORDS,
  SET_FEEDBACK_QUESTION_TYPES,
  SET_FEEDBACK_TAB,
  SET_FEEDBACK_TASK,
} from '../constants/userFeedback';

const initState = {
  feedbackTab: null,
  records: [],
  feedbackTypes: [],
  feedbackHot: false,
  feedbackTask: [], // 反馈提交任务未成功列表
};

const userFeedback = (state = initState, action = {}) => {
  let feedbackTaskTemp = [...state.feedbackTask];
  let findFeedbackTarget = null;
  const handleStr = str => {
    let len = 0;

    for (let i = 0; i < str.length; i += 1) {
      if (str.charCodeAt(i) > 255) {
        len += 2;
      } else {
        len += 1;
      }
    }
    return len > 72;
  };
  switch (action.type) {
    case SET_FEEDBACK_TAB:
      return { ...state, feedbackTab: action.payload };
    case SET_FEEDBACK_RECORDS:
      return {
        ...state,
        records:
          action.payload &&
          action.payload.length > 0 &&
          action.payload.map(item => ({
            ...item,
            showIcon: handleStr(item && item.feedbackInfo),
          })),
      };
    case SET_FEEDBACK_QUESTION_TYPES:
      return {
        ...state,
        feedbackTypes:
          action.payload &&
          action.payload.map(item => ({ ...item, name: item.typeId, text: item.typeName })),
      };
    case SET_FEEDBACK_TASK:
      findFeedbackTarget = feedbackTaskTemp.find(item => {
        return item.taskID === action.payload.taskID;
      });
      if (!action.payload.add) {
        if (findFeedbackTarget) {
          feedbackTaskTemp = feedbackTaskTemp.map(item => {
            return {
              ...item,
              status: item.taskID === action.payload.taskID ? action.payload.succ : item.status,
            };
          });
        } else {
          feedbackTaskTemp.push({
            taskID: action.payload.taskID,
            status: action.payload.succ,
          });
        }
      }

      if (!findFeedbackTarget && action.payload.add) {
        feedbackTaskTemp.push({
          taskID: action.payload.taskID,
          status: 'upload',
        });
      }
      return { ...state, feedbackTask: feedbackTaskTemp };
    default:
      return state;
  }
};

export default userFeedback;
